import { NgForm } from "@angular/forms";
import { Component, Input, ViewChild } from "@angular/core";
import { CBP7501 } from "../../../../objects/documents/CBP7501";
import { ValidationPatterns } from "../../../../common/helpers/ValidationPatterns";

@Component({
    selector: 'table-block-7501',
    templateUrl: 'table-block-7501.component.html',
    moduleId: module.id.toString()
})

export class TableBlock7501Component{
    @Input()
    public document: CBP7501;

    @ViewChild("tableBlockForm")
    public tableBlockForm: NgForm;

    public numberPatternHelper = ValidationPatterns;

    public submitFormAndValidity(): boolean{
        this.tableBlockForm.onSubmit(null);

        return this.isFormValid();
    }

    public isFormValid(): boolean{
        return this.tableBlockForm.valid;
    }

}


// WEBPACK FOOTER //
// ./app/components/export-documents/cbp-7501/document-blocks/table-block-7501.component.ts